const orderPill: Record<string, string> = {
  SUCCESS: "dash-pill dash-pill-success",
  PENDING: "dash-pill dash-pill-pending",
  MANUAL_REVIEW: "dash-pill dash-pill-review",
  FAILED: "dash-pill dash-pill-failed",
};

const agentPill: Record<string, string> = {
  active: "dash-pill dash-pill-success",
  suspended: "dash-pill dash-pill-failed",
  inactive: "dash-pill dash-pill-neutral",
};

export function OrderPill({ status }: { status: string }) {
  return <span className={orderPill[status] ?? "dash-pill dash-pill-neutral"}>{status.replace("_", " ")}</span>;
}

export function AgentPill({ status }: { status: string }) {
  return <span className={agentPill[status] ?? "dash-pill dash-pill-neutral"}>{status}</span>;
}

export function KycBadge({ status }: { status: string | null }) {
  const map: Record<string, string> = {
    approved: "ev-badge ev-badge-mint",
    submitted: "ev-badge ev-badge-amber",
    rejected: "ev-badge ev-badge-red",
    not_submitted: "ev-badge",
  };
  const label = (status ?? "not_submitted").replace("_", " ");
  return <span className={map[status ?? "not_submitted"] ?? "ev-badge"}>{label}</span>;
}
